import { render, staticRenderFns } from "./MobileMenu.vue?vue&type=template&id=5f203246&scoped=true"
import script from "./MobileMenu.vue?vue&type=script&lang=ts"
export * from "./MobileMenu.vue?vue&type=script&lang=ts"
import style0 from "./MobileMenu.vue?vue&type=style&index=0&id=5f203246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f203246",
  null
  
)

export default component.exports